/* eslint-env browser */

'use strict';

if (!window.moment) window.moment = require('moment');
require('moment/min/locales');
